<template>
    <div class="col col-4 dashboard__box-col">
        <div class="box box--dark-green">
            <h2 class="h h--2">Baza wiedzy</h2>
            <p>Lorem ipsum dolor sit amet, consectetur. Cras id tempor tortor, vel vestibulum urna.</p>
            <p><a href="" class="box__link">&raquo; Dlaczego warto stosować stelaże Geberit?</a></p>
            <a href="" class="button button__bottom">Pokaż więcej &raquo;</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'KnowledgeWidget',
  data () {
    return {
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/knowledge/KnowledgeWidget.vue